<template>
  <div>
    <div class="modal-header">
      <button type="button" class="close btn-back" @click="backToDetails">
        <i class="material-icons">keyboard_backspace</i>
      </button>
      <div class="create-forum-post-header">
        Attach {{ postType === "scenario" ? "Scenario" : "Media" }}
      </div>
      <button type="button" class="close btn-close" @click="closeModal">
        <img src="../../assets/cross-alt.svg" alt="close" />
      </button>
    </div>

    <div class="modal-body" style="padding-top: 4px">
      <ScenarioLibrary
        @on-click="selectScenario"
        v-if="postType === 'scenario'"
      />
      <MediaLibrary @on-click="selectMedia" v-if="postType === 'media'" />
    </div>
  </div>
</template>

<script>
import MediaLibrary from "./MediaLibrary";
import ScenarioLibrary from "./ScenarioLibrary";
import { mapState } from "vuex";
import { PAGES } from "@/store/createForumPostStore";
import { cloneDeep } from "lodash";

export default {
  name: "AttachExisting",
  components: {
    MediaLibrary,
    ScenarioLibrary,
  },
  computed: {
    ...mapState("createForumPostStore", {
      currentPage: (state) => state.currentPage,
      postType: (state) => state.postType,
      mediaToAttach: (state) => state.mediaToAttach,
      scenariosToAttach: (state) => state.scenariosToAttach,
    }),
  },
  methods: {
    selectScenario(scenario) {
      if (this.scenariosToAttach.find(s => s.id === scenario.id)) {
        this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
        return;
      }

      const scenariosClone = cloneDeep(this.scenariosToAttach);
      scenariosClone.push(scenario);

      this.$store.commit(
        "createForumPostStore/setScenariosToAttach",
        scenariosClone
      );

      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    selectMedia(media) {
      const mediaClone = cloneDeep(this.mediaToAttach);
      mediaClone.push(media);

      this.$store.commit("createForumPostStore/setMediaToAttach", mediaClone);
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    backToDetails() {
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    closeModal() {
      this.$store.dispatch("createForumPostStore/closeModal");
    },
  },
};
</script>

<style scoped>
.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}
.modal-header {
  border: none;
  padding-top: 24px;
}
.btn-back {
  margin: -1rem 0 -1rem -1rem;
  color: var(--isim-light-icon);
}
.btn-close {
  font-size: 16px;
}
.create-forum-post-header {
  color: black;
  font-weight: bold;
}
</style>
